import React, { useState,useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import {Routes, Route} from 'react-router-dom'

function CategoryDash (props){
    const [category, setCategory] = useState()

    // TODO: Function to get lessons in categor.


    return(
        <>
            <h1>Category Dash Page</h1>
        </>
    )
}
export default CategoryDash